
    (function(){
      'use strict';
      const nav=document.getElementById('nav-links');
      const toggle=document.getElementById('menu-toggle');
      toggle.addEventListener('click',()=>{const open=nav.classList.toggle('open');toggle.setAttribute('aria-expanded',String(open));toggle.setAttribute('aria-label',open?'Close navigation':'Open navigation');});
      nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{nav.classList.remove('open');toggle.setAttribute('aria-expanded','false');}));
      document.getElementById('year').textContent=new Date().getFullYear();
      const filters=document.querySelectorAll('.filter-btn');
      const cards=document.querySelectorAll('.gallery-card');
      filters.forEach(button=>button.addEventListener('click',()=>{const filter=button.dataset.filter;filters.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));cards.forEach(card=>card.hidden=filter!=='all'&&card.dataset.category!==filter);}));
      const dialog=document.getElementById('gallery-dialog');
      const dialogImage=document.getElementById('dialog-image');
      const dialogTitle=document.getElementById('dialog-title');
      const dialogCaption=document.getElementById('dialog-caption');
      cards.forEach(card=>card.addEventListener('click',()=>{const img=card.querySelector('img');dialogImage.src=img.currentSrc||img.src;dialogImage.alt=img.alt;dialogTitle.textContent=card.dataset.title;dialogCaption.textContent=card.dataset.type+' · Editorial photography, not a completed client project';dialog.showModal();document.body.classList.add('modal-open');}));
      const closeDialog=()=>{dialog.close();document.body.classList.remove('modal-open');};
      document.getElementById('dialog-close').addEventListener('click',closeDialog);
      dialog.addEventListener('click',e=>{if(e.target===dialog)closeDialog();});
      dialog.addEventListener('close',()=>document.body.classList.remove('modal-open'));
      document.querySelectorAll('.project-link').forEach(link=>link.addEventListener('click',()=>{const select=document.getElementById('project-type');select.value=link.dataset.project;}));
      if(document.querySelector('[data-shopify-contact-success]') || document.querySelector('#quote-form .errors')){setTimeout(()=>{location.hash='#contact';},50);}
    })();


(function(){
  'use strict';
  const routes = new Set(['home-renovations','interior-design','office-remodeling','terms','privacy','accessibility']);
  const names = {'home-renovations':'Home Renovations','interior-design':'Interior Design','office-remodeling':'Office Remodeling','terms':'Terms & Conditions','privacy':'Privacy Policy','accessibility':'Accessibility'};
  const pages = document.querySelectorAll('.route-view');
  const homeSections = new Set(['top','about','services','inspiration','process','faq','contact','main-content']);
  let mode='home';
  let preview=false;
  function navClose(){
    const list=document.getElementById('nav-links');const b=document.getElementById('menu-toggle');
    list?.classList.remove('open');b?.setAttribute('aria-expanded','false');
  }
  function view(name){
    mode = name;
    pages.forEach(p => { p.hidden = p.id !== 'view-'+name; });
    document.title = (names[name]||'Home Renovations, Interiors & Offices')+' | Heritage Guild Builders';
    navClose();
  }
  function route(){
    const hash = decodeURIComponent(window.location.hash.slice(1));
    if(hash.startsWith('/') && routes.has(hash.slice(1))){
      view(hash.slice(1));window.scrollTo(0,0);return;
    }
    const id=hash.replace(/^\//,'');
    const target=id?document.getElementById(id):null;
    if(target && target.closest('.route-view')){
      const wrapper=target.closest('.route-view');
      view(wrapper.id.substring(5));
      requestAnimationFrame(()=>target.scrollIntoView({block:'start'}));
    }else{
      view('home');
      if(!hash)window.scrollTo(0,0);
    }
  }
  document.addEventListener('click',event=>{
    const link=event.target.closest('a[href]');if(!link)return;
    const service=link.getAttribute('data-prefill-service');
    if(service){const select=document.getElementById('project-type');if(select)select.value=service;}
    // Repeated clicks on the currently selected hash also need to navigate correctly.
    if(link.getAttribute('href')===location.hash){
      setTimeout(route,0);
    }
  });
  window.addEventListener('hashchange',route);
  window.addEventListener('popstate',route);
  route();
})();